import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import UsersView from './components/UsersView';
import CompaniesView from './components/CompaniesView';

export default function UsersPage() {
  const { user } = useAuth();
  return user?.company?.type === 'ADMIN' ? <CompaniesView /> : <UsersView />;
}
